<template>
    <!-- anchor instead of a router-link in order to make Logo reusable in non-routing projects -->
    <a href="/" class="logo text-decoration-none" :class="{ cooperation }">
        <h5 v-if="cooperation" class="cooperation-text">
            In Kooperation mit
        </h5>
        <div class="logo-wrapper">
            <img :src="computedSrc" alt="animod logo" class="logo-image img-fluid"/>
        </div>
    </a>
</template>

<script>
    export default {
        name: 'Logo',
        props: {
            src: String,
            cooperation: Boolean,
            white: Boolean
        },
        computed: {
            computedSrc() {
                return this.src || (this.white
                    ? require("../assets/logo_animod2x.png")
                    : require("../assets/logo_animod_dark2x.png"));
            }
        }
    }
</script>

<style scoped lang="scss">
    .logo {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        overflow: hidden;
        color: inherit;

        .cooperation-text {
            font-size: 12px;
            text-align: center;
            margin-bottom: 5px;
            flex-shrink: 0;
        }

        .logo-wrapper {
            flex: 1;
            display: flex;
            align-items: center;
            overflow: hidden;

            .logo-image {
                max-width: 100%;
                max-height: 100%;
            }
        }
    }
</style>
